import HouseProfileView from './HouseDashboardViewContainer';
export default HouseProfileView;
